import styled from "@emotion/styled";
import { Box } from "@mui/material";

export type MediaErrorVariant = "inline" | "avatar" | "audio";

export const InlineContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  width: "100%",
  height: "100%",
  minHeight: 120,
  padding: 16,
  backgroundColor: "rgba(0,0,0,0.05)",
  borderRadius: 8,
  color: "rgba(0,0,0,0.55)",
  cursor: "pointer",
  transition: "background-color 120ms ease",
  userSelect: "none",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.08)",
  },
});

export const AvatarContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  backgroundColor: "rgba(0,0,0,0.06)",
  color: "rgba(0,0,0,0.45)",
  cursor: "pointer",
  userSelect: "none",
});

export const AudioContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  width: "100%",
  padding: "10px 16px",
  backgroundColor: "rgba(0,0,0,0.05)",
  borderRadius: 8,
  color: "rgba(0,0,0,0.6)",
  fontSize: 13,
  cursor: "pointer",
  transition: "background-color 120ms ease",
  userSelect: "none",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.08)",
  },
});

export const Label = styled(Box)({
  fontSize: 13,
  textAlign: "center",
});
